<template>
  <vertical-space :top="marginTop" :bottom="marginBottom" :backgroundColor="bgColor">
    <div class="tripple-image" :class="{'fullpage': fullpage}">
      <scroll-speed :speed="1.2">
        <div class="parallax" :class="{'max-width': maxWidth}">
          <img class="tripple-image__wrapper lazy" :data-src="image1" />
        </div>
      </scroll-speed>

      <scroll-speed :speed="1.1">
        <div class="parallax" :class="{'max-width': maxWidth}">
          <img class="tripple-image__wrapper lazy" :data-src="image2" />
        </div>
      </scroll-speed>

      <scroll-speed :speed="1">
        <div class="parallax" :class="{'max-width': maxWidth}">
          <img class="tripple-image__wrapper lazy" :data-src="image3" />
        </div>
      </scroll-speed>
    </div>
  </vertical-space>
</template>

<script>
import { mapState } from "vuex";
import LazyLoad from "vanilla-lazyload";
import scrollSpeed from "@/components/scroll-speed.vue";
import verticalSpace from "@/components/vertical-space.vue";

export default {
  name: "CaseViewSingleImage",
  components: { scrollSpeed, verticalSpace },
  props: {
    bgColor: String,
    image1: String,
    image2: String,
    image3: String,
    fullpage: Boolean,
    maxWidth: Boolean,

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 }
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy"
    });
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.tripple-image {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: $margin2-1 $margin1-1;
  @media screen and (min-width: 769px) {
    padding: $margin2-1;
    flex-wrap: nowrap;
  }
  @media screen and (min-width: 1025px) {
    padding: $margin2-1 $margin2-1;
  }

  .parallax {
    width: 100%;
    height: 100%;
    @media screen and (min-width: 769px) {
      width: calc(100% / 3);
    }
    @media screen and (min-width: 1025px) {
      width: calc(100% / 4);
    }

    &.max-width {
      max-width: 1560px;
    }
  }

  &.fullpage {
    padding-left: 0;
    padding-right: 0;
  }

  &.vertical-padding {
    @media screen and (max-width: 768px) {
      padding: $margin1-1 0;
    }
  }

  &__wrapper {
    width: 100%;
    height: auto;

    box-sizing: border-box;
    padding: 0 $margin1-4;
    @media screen and (min-width: 769px) {
      padding: 0 $margin1-2;
    }
    @media screen and (min-width: 1750px) {
      padding: 0 $margin1-1;
    }
  }
}
</style>
